import { replacePlaceholders } from '@/common/utils';

export * from '@/common/bot/flow-frameworks/ai-service/AiService.utils';

/**
 * Builds the AI welcome message shown on entry, mirroring legacy {@link AiService.connectToAI}.
 *
 * Source precedence (same as the old chatbot): an explicit per-entry-point `override`, then the
 * API-provided brand-config `aiWelcomeMessage`, then the local i18n `fallbackMessage`
 * (`chat.msg.ai.welcome_default`). The chosen text then has its `{{...}}` placeholders replaced
 * with the requester name, category and app name.
 */
export function buildAiWelcomeMessage(params: {
  aiWelcomeMessage?: string | null;
  fallbackMessage: string;
  override?: string | null;
  category?: string;
  requesterName?: string;
  appName?: string;
}): string {
  const { aiWelcomeMessage, fallbackMessage, override, category = '', requesterName = '', appName = '' } = params;

  return replacePlaceholders(override || aiWelcomeMessage || fallbackMessage, {
    category: { name: category },
    requester: { name: requesterName },
    app: { name: appName },
  });
}
